import type { UpdateSingleBillData, UpdateSingleBillHandlers } from '@ctct/application-layer';
import { Button } from '@ctct/payflow-ui';
import type { UpdateSingleBillHooks } from '@ctct/state-client-layer';

import './submit-single-bill-widget-content.scss';

interface Props {
  data: UpdateSingleBillData;
  handlers: UpdateSingleBillHandlers;
  hooks: UpdateSingleBillHooks;
}

export const SubmitSingleBillWidgetContent = ({ handlers, data, hooks }: Props) => {
  const isLoading = hooks.useIsLoading();
  const formIsDirty = hooks.useFormIsDirty();
  const paymentCanChange = hooks.usePaymentCanChange();
  const buttonLabel = data.getButtonLabel();

  const allowSave = formIsDirty || paymentCanChange;

  return (
    <Button
      disabled={isLoading || !allowSave}
      busy={isLoading}
      onClick={handlers.onSubmitClicked}
      className="submit-single-bill-widget-content__button"
    >
      {buttonLabel}
    </Button>
  );
};
